/** Safety limit to prevent infinite loops during expand-all pagination (e.g., 20 pages x 10 items = 200 max replies) */
export const MAX_EXPAND_PAGES = 20;
